<template lang="html">
  <main v-if="item" :key="item.uid">
    <div class="shop-item-view">
      <div class="shop-item-view-info">
        <div class="flex lundi li">
          <h1 class="sli">{{ item.title }}</h1>
        </div>
        <div v-for="(value, key) in item.metadata" :key="key" class="li flex">
          <div class="sli top lundi">
            {{ key }}
          </div>
          <div class="sli" v-html="value"></div>
        </div>
        <div class="li flex ai-s">
          <div class="sli top lundi cap">
            Taille
          </div>
          <div v-for="sku in item.items" :key="sku.id" class="sli">
            <span
              class="cap out_of_stock"
              v-if="sku.finite === 0"
              ></span
            >
            <span
              class="bullet cap"
              v-else
              :class="{ active: activeSku == sku, 'sold-out': sku.finite == 0 }"
              @click="
                activeSku = sku;
                sizeMissing = false;
              "
              >{{ sku.taille }}</span
            >
          </div>
          <div class="sli tooltip" v-if="sizeMissing">
            Veuillez choisir une taille
          </div>
        </div>
        <div class="li flex">
          <div class="sli lundi">
            Prix
          </div>
          <div class="sli" v-if="activeSku">{{ activeSku.price }} CHF</div>
          <div class="sli" v-else>{{ item.items[0].price }} CHF</div>
          <div class="sli" v-if="item.oldprice" style="text-decoration: line-through; text-decoration-thickness: 2px;">{{ item.oldprice }} CHF</div>
        </div>
        <div class="li flex">
          <shop-button
            v-if="checkItems()"
            :product="item"
            :sku="activeSku"
            :preorder="item.preorder"
          ></shop-button>
          <div v-else class="sli">
            Sold out
          </div>
        </div>
        <br /><br />
        <div class="li flex b-t">
          <div class="sli top lundi">
            Description
          </div>
          <div class="sli" v-html="item.description"></div>
        </div>
        <div v-for="extra in item.extras" :key="extra.title" class="li flex">
          <div class="sli top lundi">
            {{ extra.title }}
          </div>
          <div class="sli" v-html="extra.text"></div>
        </div>
      </div>
      <div class="shop-item-view-gallery">
        <div class="shop-item-slide li">
          <tiny-slider
            ref="tinySlider"
            @indexChanged="changeIndex"
            :speed="500"
            :lazyload="true"
            :mouse-drag="true"
            :loop="true"
            :items="1"
            :nav="false"
            :controls="false"
          >
            <div
              class="shop-item-slide-inner"
              v-for="image in item.images"
              :key="image.url"
              @click="nextSlide"
            >
              <img
                class="contain tns-lazy-img"
                :src="image.thumb"
                :data-src="image.url"
                :alt="item.title"
              />
            </div>
          </tiny-slider>
        </div>
        <div class="li flex jc-c" v-if="item.images.length > 1">
          <div class="sli link prev no-select" @click="prevSlide">
            Previous
          </div>
          <div class="sli counter">{{ index }}/{{ total }}</div>
          <div class="sli link next no-select" @click="nextSlide">
            Next
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
const VueTinySlider = () =>
  import(/* webpackChunkName: "TinySlider" */ "vue-tiny-slider");
const ShopButton = () =>
  import(/* webpackChunkName: "ShopButton" */ "@/components/ShopButton.vue");
export default {
  components: {
    "tiny-slider": VueTinySlider,
    ShopButton
  },
  data() {
    return {
      activeSku: null,
      sizeMissing: false,
      index: 1
    };
  },
  mounted() {
    this.$root.$on("sizeMissing", this.missingSize);
  },
  created() {
    if (this.$store.state.items.length === 0) {
      this.$store.dispatch("loadProducts");
    }
  },
  computed: {
    item() {
      return this.$store.getters.getItemByUID(this.$route.params.id);
    },
    total() {
      return this.item.images.length;
    }
  },
  methods: {
    price(value) {
      if (!value) return "";
      let amount = value / 100;
      return amount % 1 === 0 ? amount : amount.toFixed(2);
    },
    checkItems() {
            let soldout = true;
            this.item.items.forEach(item => {
                  if(item.finite > 0) {
                       soldout = false
                  }
            });
            return this.activeSku ? this.activeSku.finite > 0 : !soldout
    },
    missingSize() {
      this.sizeMissing = true;
    },
    changeIndex(data) {
      this.index = data.displayIndex;
    },
    nextSlide() {
      this.$refs.tinySlider.goTo("next");
    },
    prevSlide() {
      this.$refs.tinySlider.goTo("prev");
    }
  }
};
</script>

<style lang="scss" scoped>
.sold-out {
      pointer-events: none;
      opacity: 0.5;
}
.tns-liveregion {
  display: none !important;
}
.out_of_stock {
  color: var(--grey);
}
.shop-item-view {
  width: 100%;
  display: grid;
  grid-gap: var(--lh);
  grid-template-columns: 1fr 2fr;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    .shop-item-view-gallery {
      order: 0;
    }
    .shop-item-view-info {
      order: 1;
    }
  }
  .shop-item-view-gallery,
  .shop-item-view-info {
    grid-column: span 1;
  }
  .shop-item-view-gallery {
    .counter {
      width: calc(3.5 * var(--lh));
      text-align: center;
    }
    .shop-item-slide {
      height: calc(100vh - (6 * var(--lh)));
      cursor: pointer;
      .shop-item-slide-inner {
        height: calc(100vh - (6 * var(--lh)) - 1px);
      }
      @media only screen and (max-width: 768px) {
        height: calc(100vh - (16 * var(--lh)));
        .shop-item-slide-inner {
          height: calc(100vh - (16 * var(--lh)) - 1px);
        }
      }
    }
  }
}
</style>
